/* eslint-disable react/no-danger */
import React from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { isEmpty } from 'lodash';
import { motion } from 'framer-motion';
import Icons from '../layouts/Icons';
import BoxedContainer from '../layouts/BoxedContainer';
import { Link } from 'gatsby';

export default function PageBanner({ data }) {
  const { title, text, image, videoUrl, ctaText, isInnerPage } = data;

  const scrollToContactForm = (event) => {
    event.preventDefault();
    const contactFormElement = document.querySelector('.contact-form');
    if (contactFormElement) {
      contactFormElement.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section
      className={`relative top-0  clip-bottom-right z-5 overflow-hidden before:!inline
      before:content-[''] before:absolute before:top-0 before:w-full before:bg-black
      before:lg:bg-opacity-70 before:bg-opacity-50 ${
        isInnerPage
          ? 'lg:h-[809px] h-[600px] before:h-[809px]'
          : 'lg:h-[957px] h-[570px] before:h-[957px]'
      }`}>
      {image && (
        <LazyLoadImage src={image.url} alt="banner image" className="w-full h-full object-cover" />
      )}
      <motion.div
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.4, delay: 0.8 }}
        className="absolute top-0 flex flex-col justify-center items-center h-full w-full
        lg:pt-0 pt-24">
        <BoxedContainer className="regular">
          <div className="flex flex-col justify-center items-center h-full w-full">
            <div
              className={`text-center flex flex-col items-center lg:gap-y-[70px] gap-y-[57px]
              ${isInnerPage ? 'lg:w-[100%]' : 'lg:w-[67%]'}`}>
              {isEmpty(title) || (
                <h1
                  className="flex flex-col font-roboto-condensed-bold uppercase
                  text-white lg:tracking-[11px] tracking-[3px] relative before:content-['']
                  before:!inline before:absolute before:lg:-bottom-[3rem] before:-bottom-[45px]
                  before:left-1/2 before:h-10 before:w-[2px] before:bg-white leading-none"
                  dangerouslySetInnerHTML={{ __html: title }}
                  style={{
                    fontSize: 'clamp(2.5rem, 2.439vw + 2.073rem, 5rem)',
                  }}
                />
              )}

              {isEmpty(text) || (
                <div
                  className={`text-white leading-[1.75]
                  font-roboto-regular text-center  flex flex-col
                  lg:gap-y-[1.5rem] gap-y-3 items-center
                  ${
                    isInnerPage
                      ? '2xl:max-w-[900px]'
                      : '2xl:px-[2rem] lg:px-[1rem] 2xl:max-w-[633px] max-w-[500px]'
                  }`}
                  style={{
                    fontSize: 'clamp(0.875rem, 0.244vw + 0.832rem, 1.125rem)',
                  }}>
                  <div dangerouslySetInnerHTML={{ __html: text }} />

                  {isEmpty(ctaText) || (
                    <button
                      type='button'
                      onClick={scrollToContactForm}
                      className="bg-red hover:shadow-sm hover:bg-white hover:text-black
                      hover:border-red text-xs text-white uppercase rounded-sm font-roboto-bold 
                      border border-red flex cursor-pointer items-center justify-center 
                      min-h-[42px] px-6 py-2 text-center font-bold not-italic disabled:opacity-10 
                      disabled:pointer-events-none transition duration-300 ease-in-out">
                      {ctaText}
                    </button>
                  )}

                  <Icons icon="arrow-head" className="!block w-[12px]" />
                </div>
              )}
            </div>
          </div>
        </BoxedContainer>
      </motion.div>
    </section>
  );
}
